import { AxiosInstance } from "axios";

export const institutionDetailsAndTreatmentsAPI = (api: AxiosInstance) => ({
  fetchDetailsAndTreatments: (orgUnitUUID: string) => api.get(`/org-unit/${orgUnitUUID}`),
});
